import React, { createContext, useContext, useState } from 'react';

const ViewerOrderContext = createContext();

export const ViewerOrderProvider = ({ children }) => {
  const [orderData, setOrderData] = useState({
    data: {
      template_name: '',
      dicom_study_id: '',
      clinical_notes: '',
      clinical_doc_array: [],
      html_report: null,
      raw_report: ''
    },
    viewerToken: '',
    orderId: '',
    displayOrderId: '',
    labUserId: '',
    caseId: ''
  });

  return (
    <ViewerOrderContext.Provider value={{ orderData, setOrderData }}>
      {children}
    </ViewerOrderContext.Provider>
  );
};

export const useOrder = () => {
  const context = useContext(ViewerOrderContext);
  if (!context) {
    throw new Error('useOrder must be used within a ViewerOrderProvider');
  }
  return context;
};

export default ViewerOrderContext; 